import AUX from '../../../hoc/Aux_';
import { io } from 'socket.io-client';
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSocketAPI } from '../../../Constant';
import moment from 'moment';
import { FaPaperPlane } from 'react-icons/fa';
import { getAdminUser, getDomainUser } from '../../../redux/MainAction';

const groupMessagesByDate = (messages) => {
  return messages.reduce((groups, message) => {
    const messageDate = moment(message.createdAt);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    let dateKey;
    if (messageDate.isSame(today, 'd')) {
      dateKey = 'Today';
    } else if (messageDate.isSame(yesterday, 'd')) {
      dateKey = 'Yesterday';
    } else {
      dateKey = messageDate.format('MMMM D, YYYY');
    }

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(message);
    return groups;
  }, {});
};

const AdminEmployeeChat = () => {
  const dispatch = useDispatch();
  const domains = useSelector((state) => state?.Webtracker?.chatEmployee?.rows);

  const chatContainerRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [socket, setSocket] = useState(null);
  const authToken = localStorage.getItem('loged_In_auth');
  const userId = localStorage.getItem('userId');
  const [workspaceId, setWorkspaceId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    dispatch(getAdminUser());
  };

  useEffect(() => {
    if (domains && domains?.length !== 0) setWorkspaceId(domains?.[0]?.id);
  }, [domains]);

  const filteredDomains = domains?.filter((user) =>
    `${user.firstName} ${user.lastName}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  function isMessageSent(messageId) {
    return messageId === userId;
  }

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [messages]);

  useEffect(() => {
    if (userId && authToken && workspaceId) {
      if (socket) {
        socket.disconnect();
      }

      const socketInstance = io(
        `${getSocketAPI()}/user?token=${authToken}&ownerId=${userId}`
      );

      setSocket(socketInstance);

      socketInstance.on('connect', () => {
        socketInstance.emit('/chat/employee/message/list', {
          employeeId: workspaceId,
        });
      });

      socketInstance.on('/chat/employee/message/list', (response) => {
        setMessages(
          response?.data?.rows ? response?.data?.rows?.toReversed() : []
        );
      });

      socketInstance.on('connect_error', (error) => {
        console.error('Socket connection error:', error, socketInstance);
      });

      socketInstance.on('/chat/employee/message/receive', (response) => {
        setMessages((prevMessages) => [...prevMessages, response?.data]);
      });

      return () => {
        socketInstance.disconnect();
      };
    }
  }, [authToken, userId, workspaceId]);

  const groupedMessages = groupMessagesByDate(messages || []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      socket.emit('/chat/employee/message/send', {
        message: newMessage,
        employeeId: workspaceId,
      });

      const userMessage = {
        message: newMessage,
        fromId: userId,
        createdAt: new Date().toISOString(),
      };

      setMessages([...messages, userMessage]);
      setNewMessage('');
    }
  };
  console.log('workspaceId', workspaceId);

  return (
    <AUX>
      <div
        className="page-content-wrapper chat-box-container"
        style={{ display: 'flex' }}
      >
        <div
          style={{
            width: '25%',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '45px',
              cursor: 'pointer',
              textTransform: 'capitalize',
            }}
          >
            <input
              className="border border-primary w-100 h-100 px-2"
              type="search"
              placeholder="Search Employee..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div
            style={{
              overflowY: 'auto',
              backgroundColor: 'white',
              borderRight: '1px solid #ccc',
              height: 'calc(100vh - 177px)',
            }}
            className="superadmin_chat_users"
          >
            {filteredDomains &&
              (filteredDomains?.length === 0 ? (
                <div
                  style={{
                    textAlign: 'center',
                    color: '#888',
                    marginTop: '20px',
                  }}
                >
                  No domain found
                </div>
              ) : (
                filteredDomains.map((user) => (
                  <div
                    key={user.id}
                    onClick={() => setWorkspaceId(user?.id)}
                    className="border-bottom"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px',
                      cursor: 'pointer',
                      textTransform: 'capitalize',
                      ...(workspaceId === user?.id
                        ? {
                            backgroundColor: '#f9fbfe',
                            color: 'rgb(13, 71, 161)',
                          }
                        : {}),
                    }}
                  >
                    {user.media && user.media.url ? (
                      <img
                        src={user.media.url}
                        alt={`${user.firstName} ${user.lastName}`}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          marginRight: '10px',
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: 'rgb(13, 71, 161)',
                          color: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '10px',
                          fontSize: '18px',
                        }}
                      >
                        {user.firstName.charAt(0)}
                      </div>
                    )}
                    <div
                      style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {`${user.firstName} ${user.lastName}`}
                    </div>
                  </div>
                ))
              ))}
          </div>
        </div>

        <div style={{ width: '75%', display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              width: '100%',
              height: '50px',
              backgroundColor: 'rgb(13, 71, 161)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              fontSize: '18px',
              padding: '10px 16px',
              textTransform: 'capitalize',
            }}
          >
            {domains &&
              workspaceId &&
              domains?.length !== 0 &&
              `${domains?.find((domain) => domain?.id === workspaceId)?.firstName} ${domains?.find((domain) => domain?.id === workspaceId)?.lastName}`}
          </div>

          <div
            ref={chatContainerRef}
            style={{
              height: 'calc(100vh - 267px)',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              padding: '10px',
            }}
          >
            {messages.length === 0 ? (
              <div
                style={{
                  textAlign: 'center',
                  color: '#888',
                  marginTop: '20px',
                }}
              >
                No messages here to display
              </div>
            ) : (
              Object.entries(groupedMessages).map(([date, dateMessages]) => (
                <React.Fragment key={date}>
                  <div
                    style={{
                      textAlign: 'center',
                      margin: '10px 0',
                      color: '#888',
                    }}
                  >
                    {date}
                  </div>
                  {dateMessages.map((message, idx) => (
                    <div
                      key={idx}
                      style={{
                        alignSelf: isMessageSent(message.fromId)
                          ? 'flex-end'
                          : 'flex-start',
                        backgroundColor: isMessageSent(message.fromId)
                          ? 'rgb(13, 71, 161)'
                          : '#f9fbfe',
                        color: isMessageSent(message.fromId)
                          ? 'white'
                          : 'black',
                        borderRadius: '20px',
                        padding: '10px 15px',
                        margin: '5px',
                        minWidth: '125px',
                        maxWidth: '70%',
                      }}
                    >
                      <div>{message.message}</div>
                      <div
                        style={{
                          fontSize: '0.8em',
                          textAlign: 'right',
                          marginTop: '5px',
                          opacity: 0.7,
                        }}
                      >
                        {moment(message.createdAt).format('hh:mm A')}
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              ))
            )}
          </div>

          <div style={{ padding: '0 15px', marginTop: '10px' }}>
            <form onSubmit={handleSubmit} style={{ display: 'flex' }}>
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type your message..."
                style={{
                  flexGrow: 1,
                  marginRight: '10px',
                  padding: '10px',
                  borderRadius: '20px',
                  border: '1px solid #ccc',
                }}
              />
              <button
                type="submit"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '20px',
                  color: '#007bff',
                }}
              >
                <FaPaperPlane />
              </button>
            </form>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default AdminEmployeeChat;
